import { render } from "./PatientDrugList.vue?vue&type=template&id=1f8d8fee"
import script from "./PatientDrugList.vue?vue&type=script&lang=js"
export * from "./PatientDrugList.vue?vue&type=script&lang=js"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__